import { Button, Dialog, DialogContent, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { initShippingInvoiceExportData, initShippingInvoiceImportData } from "./initData"
import { DocumentScannerRounded } from "resource/muiImport"
import { UserContext } from "contexts/UserContext"
import { shippingApiNm } from "./shippingApiNm"
import dayjs from "dayjs"
import FileUpload from "components/FileUplaod/FileUpload"
import { saveFile } from "components/FileUplaod/saveFile"
import { alertError, alertWarning } from "components/Alert"
import Swal from "sweetalert2"
import ReadBookingDialog from "./ReadBookingDialog"
import ImportField from "branch/constant/shipping/ImportField"
import ExportField from "branch/constant/shipping/ExportField"
import ReadBLDialog from "./ReadBLDialog"
import { shipmentApiNm } from "constants/shipmentConstant"
import FilePreviewComponent from "pages/Menu1/DailyJob/DailyJobDialogV4Component/FilePreviewComponent"


const getContSizeText = (jobOrder) => {
  let text = jobOrder.ContSize
  if (text !== "บรรทุก") {
    if (jobOrder.ContTyp === "GP") {
      if (jobOrder.ContHq === 1) {
        text = `${text}HQ`
      } else {
        text = `${text}GP`
      }
    } else if (jobOrder.ContTyp === "RF") {
      if (jobOrder.ContHq === 1) {
        text = `${text}RH`
      } else {
        text = `${text}RF`
      }
    } else {
      text = `${text}${jobOrder.ContTyp}${jobOrder.ContHq === 1 ? "HQ" : ""}`
    }
  }
  return text
}
export const groupJobOrderByContSizeFull = (jobOrders) => {
  if (!jobOrders || jobOrders.length === 0) {
    return []
  }
  const groupedData = jobOrders.reduce((acc, jobOrder) => {
    const key = `${jobOrder.ContSize}-${jobOrder.ConttTyp}-${jobOrder.ContHq}`;
    if (!acc[key]) {
      let text = getContSizeText(jobOrder)
      acc[key] = {
        ContSize: jobOrder.ContSize,
        ContTyp: jobOrder.ContTyp,
        ContHq: jobOrder.ContHq,
        text: text,
        count: 0,
        NumJobOrd: 0,
        ShpmId: jobOrder.ShpmId || 0,
      };
    }
    acc[key].count++;
    acc[key].NumJobOrd++;
    return acc;
  }, {});
  return Object.values(groupedData);
}
const initFiles = {
  serverFiles: [],
  addedFiles: [],
  deletedFiles: [],
}
export const shpTypCombo = [
  { id: 1, label: "เรือ" },
  { id: 2, label: "รถ" },
  { id: 3, label: "เครื่องบิน" },
  { id: 4, label: "รถไฟ" },
]
// const NumberObject = ({ children, label }) => {
//   return (
//     <BoxFR>
//       <Typography fontWeight="bold">{label}</Typography>
//       {children}
//     </BoxFR>
//   )
// }

let oData = {}

let originalFileUploadDataSh = null;
let originalFileUploadDataBL = null;
let originalFileUploadDataFrt = null;
let originalFileUploadDataCstm = null;


const ShippingInvoiceDialogV2 = ({ selectedId, dialogOpen, setDialogOpen, onFinish, mode }) => {

  const { ax } = useContext(GlobalStateContext)
  const { user } = useContext(UserContext)
  const [dialogData, setDialogData] = useState({ ...(mode === "IM" ? initShippingInvoiceImportData : initShippingInvoiceExportData) })
  const [shFiles, setShFiles] = useState({ ...initFiles })
  const [blFiles, setBLFiles] = useState({ ...initFiles })
  const [frtFiles, setFrtFiles] = useState({ ...initFiles })
  const [cstmFiles, setCstmFiles] = useState({ ...initFiles })
  const [dialogReadFileBookingOpen, setDialogReadFileBookingOpen] = useState(false)
  const [dialogReadFileBLOpen, setDialogReadFileBLOpen] = useState(false)

  const allJobOrderFiles = useMemo(() => {
    if (!dialogData.JobOrders) return []
    return dialogData.JobOrders.flatMap(jo => jo.JobOrdFiles || [])
  }, [dialogData.JobOrders])


  // const cneeMemo = useMemo(() => {
  //   const ctt = msData.cusCombo.find(c => c.id === ownCompanyCusId)
  //   const othCus = msData.cusCombo.filter(c => c.id !== ownCompanyCusId)
  //   ctt.group = "บริษัท"
  //   return [ctt, ...othCus.map(c => ({ ...c, group: "บริษัทอื่นๆ" }))]
  // }, [msData.cusCombo])





  const handleDialogOk = useCallback(async () => {
    if (!dialogData.RecvDocDte || !dialogData.JobNo || !dialogData.JobId || !dialogData.CusId) {
      alert("กรุณาตรวจสอบข้อมูลให้ครบถ้วน")
      return
    }
    let hasChange = false
    const contNos = dialogData.ContNoStr ? dialogData.ContNoStr.toUpperCase().split(/[\n,]+/).map(no => no.trim()).filter(no => no) : []
    let shpInvId = dialogData.ShpInvId
    let shpmId = dialogData.ShpmId
    if (!dialogData.ShpInvId) {
      if (dialogData.GroupJobOrders.some(jo => !jo.ContSize || !jo.ContTyp || jo.ContHq == null)) {
        alertError("กรุณาระบุขนาดตู้และประเภทตู้ให้ครบถ้วน")
        return
      }
      const postData = {
        ...dialogData,
        ContNos: contNos,
        DemFreeTm: dialogData.DemFreeTm ? +dialogData.DemFreeTm : null,
        DetFreeTm: dialogData.DetFreeTm ? +dialogData.DetFreeTm : null,
        getArgs: null,
        WithShpmId: 1
      }
      console.log("postData", postData)
      const returnValue = await ax.post(shippingApiNm.insertShippingInvWithJobOrders, postData)
      if (returnValue.data) {
        shpmId = returnValue.data.ShpmId
        shpInvId = returnValue.data.ShpInvId
        // onFinish(value.data)
        // setDialogOpen(false)
        hasChange = true
      } else {
        return
      }
    } else {
      const shpmColValues = {}
      const shpColValues = {}
      const shpmCols = ["Bkg", "RecvDocDte", "ETA", "Vssl", "Voy", "Agnt", "JobNo", "CusId", "JobId", "ShpmTypId", "CusRefNo", "Port"]
      Object.keys(dialogData).forEach(key => {
        if (oData[key] !== dialogData[key] && key !== "ContNos" && key !== "ContNoStr" && key !== 'JobOrders' && key !== 'GroupJobOrders' && key !== 'Vol') {
          if (shpmCols.includes(key)) {
            shpmColValues[key] = dialogData[key]
          } else {
            shpColValues[key] = dialogData[key]
          }
        }
      })
      const newJobOrders = dialogData.GroupJobOrders.filter(jo => !jo.ShpmId)
      if (Object.keys(shpColValues).length > 0) {
        const postData = {
          ShpInvId: dialogData.ShpInvId,
          ColValues: shpColValues,
        }
        await ax.post(shippingApiNm.updateShippingInvoiceColumns, postData)
        hasChange = true
      }
      if (Object.keys(shpmColValues).length > 0) {
        const postData = {
          ShpmId: dialogData.ShpmId,
          ColValues: shpmColValues,
        }
        await ax.post(shippingApiNm.updateShipmentColumns, postData)
        hasChange = true
      }
      if (JSON.stringify(oData.ContNos || []) !== JSON.stringify(contNos)) {
        hasChange = true
        await ax.post(shippingApiNm.updateShippingContNos, { ShpInvId: shpInvId, ContNos: contNos })
      }
      if (newJobOrders.length > 0) {
        hasChange = true
        const postData = {
          GroupJobOrders: newJobOrders,
          ShpmId: dialogData.ShpmId,
          TakePOIID: dialogData.TakePOIId,
          RtnPOIID: dialogData.RtnPOIId,
          TakeDteSt: dialogData.TakeDteSt,
          RtnDteSt: dialogData.RtnDteSt,
          RtnDteEn: dialogData.RtnDteEn,
          JobId: dialogData.JobId,
        }
        await ax.post(shippingApiNm.insertJobOrders, postData)
      }


    }
    const localSaveFile = (fileUploadData, setFileUploadData, ShpFileTypId, isShFile) => saveFile({
      ax,
      alertWarning: alertWarning,
      fileUploadData: fileUploadData,
      setFileUploadData: setFileUploadData,
      apiUpdateFileName: isShFile ? shipmentApiNm.updateFileName : shippingApiNm.updateFileName,
      apiDeleteFile: isShFile ? shipmentApiNm.deleteFile : shippingApiNm.deleteFile,
      apiAddFile: isShFile ? shipmentApiNm.uploadFile : shippingApiNm.uploadFile,
      key: isShFile ? "ShpmFileId" : "ShpFileId",
      refKey: isShFile ? "ShpmId" : "ShpInvId",
      refValue: isShFile ? shpmId : shpInvId,
      extraColValues: isShFile ? null : { ShpFileTypId: ShpFileTypId }
    })
    if (originalFileUploadDataSh !== JSON.stringify(shFiles)) {
      hasChange = true
      await localSaveFile(shFiles, setShFiles, null, true)
    }
    if (originalFileUploadDataBL !== JSON.stringify(blFiles)) {
      hasChange = true
      await localSaveFile(blFiles, setBLFiles, 8)
    }
    if (originalFileUploadDataFrt !== JSON.stringify(frtFiles)) {
      hasChange = true
      await localSaveFile(frtFiles, setFrtFiles, 10)
    }
    if (originalFileUploadDataCstm !== JSON.stringify(cstmFiles)) {
      hasChange = true
      await localSaveFile(cstmFiles, setCstmFiles, 14)
    }
    if (hasChange) {
      onFinish(null)
    }
    setDialogOpen(false)
    // console.log('Changed fields:', ColValues)
  }, [ax, dialogData, onFinish, setDialogOpen, blFiles, cstmFiles, frtFiles, shFiles])

  const handleDeleteShippingInvoice = useCallback(() => {
    if (dialogData.ShpInvId) {
      Swal.fire({
        text: "ต้องการลบข้อมูลใบแจ้งลากด้วยหรือไม่?",
        icon: 'question',
        showDenyButton: true,
        denyButtonText: `ลบเฉพาะข้อมูล Shipping`,
        confirmButtonText: 'ลบข้อมูลทั้งหมด',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        denyButtonColor: '#9c27b0',
        cancelButtonColor: '#d33',
      }).then((result) => {
        let postData = null
        if (result.isConfirmed) {
          postData = { ShpInvId: dialogData.ShpInvId, WithShipment: 1, ShpmId: dialogData.ShpmId }
        } else if (result.isDenied) {
          postData = { ShpInvId: dialogData.ShpInvId }
        }
        if (postData) {
          if (postData.WithShipment) {
            if (dialogData.JobOrders.length > 0) {
              alertError("ไม่สามารถลบข้อมูลได้ เนื่องจากมีงบงานที่เกี่ยวข้องผูกอยู่")
              return
            }
          }
          ax.post(shippingApiNm.deleteShippingInvoice, postData).then(value => {
            if (value.data) {
              onFinish(null)
              setDialogOpen(false)
            }
          })
        }
      })
    }
  }, [ax, dialogData.ShpInvId, dialogData.ShpmId, dialogData.JobOrders.length, onFinish, setDialogOpen])

  // const handleSearch = useCallback(() => {
  //   var win = window.open(window.location.origin + `/emily/DailyJob/ShpmId/${dialogData.ShpmId}`, '_blank');
  //   win.focus();
  // }, [dialogData.ShpmId])


  const onDialogReadFileFinish = useCallback((data) => {
    console.log("onDialogReadFileFinish", data)
    let vol = ""
    const groupArr = []
    if (data.VolArr) {
      for (const item of data.VolArr) {
        const found = groupArr.find(g => g.ContSize === item.ContSize
          && g.ContTyp === item.ContTyp && g.ContHq === item.ContHq)
        if (found) {
          found.NumJobOrd += item.Qty
        } else {
          groupArr.push({ ...item, NumJobOrd: +item.Qty })
        }
      }
      vol = groupArr.map(item => `${item.NumJobOrd}x${getContSizeText(item)}`).join(", ")
    }
    setDialogData(o => {
      return {
        ...o,
        Agnt: data.Agnt,
        Bkg: data.Bkg,
        JobNo: o.JobNo ? o.JobNo : data.Bkg,
        CT: data.CT,
        CneeId: data.CneeId,
        ContNos: data.ContNos,
        ETA: data.ETA,
        KGM: data.KGM,
        M3: data.M3,
        Port: data.Port,
        TakePOIId: data.TakePOIId,
        RtnPOIId: data.RtnPOIId,
        TakeDteSt: data.TakeDteSt,
        RtnDteSt: data.RtnDteSt,
        RtnDteEn: data.RtnDteEn,
        GroupJobOrders: data.VolArr ? data.VolArr.map(vo => ({
          NumJobOrd: vo.Qty,
          ContSize: vo.ContSize,
          ContTyp: vo.ContTyp,
          ContHq: vo.ContHq,
          TlrTypId: 1,
          AptTm: null
        })) : [],
        Vssl: data.Vssl,
        Voy: data.Voy,
        Vol: vol
      }
    })

    setShFiles(o => ({
      ...o,
      addedFiles: [
        ...o.addedFiles,
        {
          file: data.file,
          fileNm: data.file.name,
          label: data.file.name,
          isEdit: false,
          imgLink: URL.createObjectURL(data.file)
        }
      ]
    }))
  }, [])

  const handleOpenDialogReadFile = useCallback(() => {
    if (mode === "IM") {
      setDialogReadFileBLOpen(true)
    } else {
      setDialogReadFileBookingOpen(true)
    }
  }, [mode])



  useEffect(() => {
    if (dialogOpen) {
      if (!selectedId) {
        setDialogData({
          ...(mode === "IM" ? initShippingInvoiceImportData : initShippingInvoiceExportData),
          RecvDocDte: dayjs(),
          BLRecvTm: dayjs(),
          ManAccId: user.AccId
        })
      } else {
        ax.post(shippingApiNm.getShippingInvoiceDetail, { ShpInvId: selectedId }).then(value => {
          if (value.data) {

            const getFileObj = file => ({
              id: file.ShpFileId,
              fileNm: file.FileNm,
              label: file.Label,
              oLabel: file.Label,
              ShpInvId: selectedId,
              isEdit: false,
              file: null,
              imgLink: `${window.location.origin}/file/shipping/${file.ShpInvId}/${file.FileNm}`,
            })
            const getFileObjSh = file => ({
              id: file.ShpmFileId,
              fileNm: file.FileNm,
              label: file.Label,
              oLabel: file.Label,
              ShpmId: file.ShpmId,
              isEdit: false,
              file: null,
              imgLink: `${window.location.origin}/file/shipment/${file.ShpmId}/${file.FileNm}`,
            })
            const serverFilesSh = value.data[0].ShFiles.map(getFileObjSh)
            const serverFilesBL = value.data[0].Files.filter(file => file.ShpFileTypId === 8).map(getFileObj)
            const serverFilesFrt = value.data[0].Files.filter(file => file.ShpFileTypId === 10).map(getFileObj)
            const serverFilesCstm = value.data[0].Files.filter(file => file.ShpFileTypId === 14).map(getFileObj)

            setShFiles(o => {
              const newData = { ...o, serverFiles: serverFilesSh }
              originalFileUploadDataSh = JSON.stringify(newData)
              return newData
            })
            setBLFiles(o => {
              const newData = { ...o, serverFiles: serverFilesBL }
              originalFileUploadDataBL = JSON.stringify(newData)
              return newData
            })
            setFrtFiles(o => {
              const newData = { ...o, serverFiles: serverFilesFrt }
              originalFileUploadDataFrt = JSON.stringify(newData)
              return newData
            })
            setCstmFiles(o => {
              const newData = { ...o, serverFiles: serverFilesCstm }
              originalFileUploadDataCstm = JSON.stringify(newData)
              return newData
            })

            const groupedArray = groupJobOrderByContSizeFull(value.data[0].JobOrders)
            // console.log('Grouped job orders:', groupedArray);
            // setJobCombo(msData.jobCombo.filter(j => j.refId === value.data[0].CusId))
            let vol = ""
            const groupArr = []
            if (value.data[0].JobOrders) {
              for (const item of value.data[0].JobOrders) {
                // console.log("item:: ", item)
                const found = groupArr.find(g => g.ContSize === item.ContSize
                  && g.ContTyp === item.ContTyp && g.ContHq === item.ContHq)
                if (found) {
                  found.NumJobOrd += 1
                } else {
                  groupArr.push({ ...item, NumJobOrd: 1 })
                }
              }
              // console.log("groupArr:: ", groupArr)
              vol = groupArr.map(item => `${item.NumJobOrd}x${getContSizeText(item)}`).join(", ")
            }
            oData = { ...value.data[0], JobOrders: value.data[0].JobOrders.map(j => ({ ...j, })) }
            setDialogData({
              ...value.data[0],
              Vol: vol,
              GroupJobOrders: groupedArray,
            })
          }
        })
      }
    } else {
      setDialogData({ ...initShippingInvoiceImportData })
      // setJobCombo([])
      setShFiles({
        serverFiles: [],
        addedFiles: [],
        deletedFiles: [],
      })
      setBLFiles({
        serverFiles: [],
        addedFiles: [],
        deletedFiles: [],
      })
      setFrtFiles({
        serverFiles: [],
        addedFiles: [],
        deletedFiles: [],
      })
      setCstmFiles({
        serverFiles: [],
        addedFiles: [],
        deletedFiles: [],
      })
    }
  }, [dialogOpen, ax, selectedId, user.AccId, mode])

  // useEffect(() => {
  //   if (dialogData.GroupJobOrders) {
  //     setDialogData(o => ({ ...o, Vol: o.GroupJobOrders?.map(vo => `${vo.NumJobOrd}x${getContSizeText(vo)}`)?.join(", ") }))
  //   }
  // }, [dialogData.GroupJobOrders])

  useEffect(() => {
    if (dialogData.ContNos) {
      setDialogData(o => ({ ...o, ContNoStr: dialogData.ContNos.map(contNo => contNo.trim()).join("\n") }))
    }
  }, [dialogData.ContNos])

  // console.log("dialogData::", dialogData)
  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      PaperProps={{ sx: { maxWidth: 1650, minWidth: 1650, width: 1650 } }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายละอียดงาน"
        onDeleteClick={handleDeleteShippingInvoice}
      >
        <BoxFR ml={2}>
          <Button variant="contained" color="secondary" onClick={handleOpenDialogReadFile}>
            <DocumentScannerRounded sx={{ mr: 1 }} />
            อ่านไฟล์ {mode === "IM" ? "B/L" : "Booking"}</Button>
        </BoxFR>
      </DialogHeader>
      <DialogContent sx={{pb:0, mb:0}}>
        <BoxFR pt={2} sx={{ alignItems: "stretch" }}>
          {mode === "IM" ? <ImportField
            dialogData={dialogData}
            setDialogData={setDialogData} /> :
            <ExportField
              dialogData={dialogData}
              setDialogData={setDialogData}
            />}
          <BoxFC sx={{gap: 1}} height={620}>
            <BoxFR flex={1}>
              <BoxFC sx={{ gap: 1, height: "100%" }}>

                <Typography variant="h6"> ไฟล์ {mode === "IM" ? "B/L" : "Booking"}</Typography>
                <FileUpload
                  width={265}
                  options={[mode === "IM" ? "B/L" : "Booking", "ใบแจ้งลาก"]}
                  fileUploadData={shFiles}
                  setFileUploadData={setShFiles}
                />
                <Typography variant="h6"> ไฟล์ ก่อนปิดตู้</Typography>
                <FileUpload
                  width={265}
                  options={["Phyto", "Form E", "Form D"]}
                  fileUploadData={blFiles}
                  setFileUploadData={setBLFiles}
                />
              </BoxFC>
              <BoxFC sx={{ gap: 1, height: "100%"  }}>
                <Typography variant="h6"> ไฟล์ สายเรือ</Typography>
                <FileUpload
                  width={265}
                  options={["Inv สายเรือ", "Pay in slip"]}
                  fileUploadData={frtFiles}
                  setFileUploadData={setFrtFiles}
                />
              </BoxFC>
              <BoxFC sx={{ gap: 1, height: "100%"  }}>
                <Typography variant="h6"> ไฟล์ ศุลกากร</Typography>
                <FileUpload
                  width={265}
                  options={["ใบขน", "ล่วงเวลา"]}
                  fileUploadData={cstmFiles}
                  setFileUploadData={setCstmFiles}
                />
              </BoxFC>

            </BoxFR>
            <FilePreviewComponent
              label="รูปใบงาน"
              readOnly={true}
              filesData={allJobOrderFiles}
              jobOrdId={dialogData.JobOrders?.[0]?.JobOrdId}
              joData={dialogData.JobOrders?.[0]}
            />
          </BoxFC>
        </BoxFR>

        <ReadBookingDialog
          dialogOpen={dialogReadFileBookingOpen}
          setDialogOpen={setDialogReadFileBookingOpen}
          onFinish={onDialogReadFileFinish} />
        <ReadBLDialog
          dialogOpen={dialogReadFileBLOpen}
          setDialogOpen={setDialogReadFileBLOpen}
          onFinish={onDialogReadFileFinish}
        />

      </DialogContent>
      <DialogFooter okText={"บันทึก"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(ShippingInvoiceDialogV2)